import React, {useEffect, useState} from "react";
import {withRouter} from "react-router-dom";
import {Users, User} from "./pages/users";
import {
    Cols,
    Filter,
    ExtraFields,
    Export,
    Order,
    Task,
    Account,
    Contact,
    Invoice,
    Product,
    Profile,
    Lead,
    Opportunity,
    Project,
    Case,
    Document,
    WorkWithList,
    Import,
    BpRules, MsgBroadcast
} from "./pages/wrap";
import {
    BotAddPayment,
    BotAskQuestion, BotCard, BotConnectChat,
    BotFilter, BotSaveField, BotSendImage, BotSendMail, BotSendMessage,
    BotSettings, BotSwitchFunnel, BotSendSms,
    Info, TriggerMessage, CreateFunnel, BotUser, BotAttr, BotHttpRequest
} from './pages/ChatBot'
import {
    BpActions,
    bpAddTask,
    BpFields,
    BpInfo,
    bpSendEmail,
    bpTags,
    editFields,
    bpNotifications,
    createEntity,
    bpAddToTeam,
    allOfFields, twig
} from "./pages/Bp";
import {CSSTransition} from "react-transition-group";
import {
    DocumentTemplates,
    Login, PasswordRecovery,
    Registration,
    RfmSegmentation,
    Segmentation,
    SmsSending,
    Twig
} from "./pages/TopLevel";
import {Checkbox} from "./pages/Integration";

const ComingSoon = "<p>Раздел находится на стадии разработки.</p>"

const pages = {
    "group": Users, "users": User, "cols": Cols, "filter": Filter, "extrafields": ExtraFields, "export": Export, "order": Order, "task": Task,
    "account": Account, "contact": Contact, "invoice": Invoice, 'product': Product, "profile": Profile, "lead": Lead, "opportunity": Opportunity,
    "project": Project, "case": Case, "document": Document, "botinformation": Info, "bpfields": BpFields, "bottriggermessage": TriggerMessage,
    "bpinformation": BpInfo, "bpactions": BpActions, "bpaddtask": bpAddTask, "bpsendmail": bpSendEmail, "bpedittags": bpTags, "bpeditfield": editFields,
    "bpnotifications": bpNotifications, "bpaddentity": createEntity, "bpaddteam": bpAddToTeam, "list": WorkWithList, "import": Import, "botsettings": BotSettings,
    "botfilter": BotFilter, "botsendmessage": BotSendMessage, "botaskquestion": BotAskQuestion, "botsendpicture": BotSendImage, "botsendcard": BotCard,
    "botswitchfunnel": BotSwitchFunnel, 'botsavefield': BotSaveField, "botaddpayment": BotAddPayment, "botsendemail": BotSendMail, "botconnectchat": BotConnectChat,
    "botsendsms": BotSendSms, "bot-funnel-create": CreateFunnel, "botusers": BotUser, "botattr": BotAttr, "botsendrequest": BotHttpRequest, "sms-sending": SmsSending,
    "documenttemplates": DocumentTemplates, "segmentation": Segmentation, "rfm": RfmSegmentation, "registration": Registration, "login": Login,
    "password-recovery": PasswordRecovery, "b_rules": BpRules, "messengers-sending": MsgBroadcast, "integration_checkbox": Checkbox, "allfields": allOfFields,
    "twig": twig
}

const Content = (props) => {
    const [full, setFull] = useState("")

    useEffect(() => {
        setFull(window.location.host.split('.')[0])
    }, [])

    return <div>
        {full === "localhost:3000" && <button onClick={() => props.history.push({pathname:"editor", state: {
            data: pages[props.match.params.id]
            }})}>edit</button>}
        {
            <p dangerouslySetInnerHTML={{__html: pages[props.match.params.id]}} />
        }
    </div>
}

export default withRouter(Content)